<template>
  <div>
    <div
      v-if="hasAnsweredSecurityQuestion"
      class="mb-8 ml-1"
    >
      <input
        id="change-security-question"
        v-model="updateSecurityQuestion"
        type="checkbox"
        name="change-security-question"
        :value="true"
      >
      <label
        for="change-security-question"
        v-text="'Change Security Question'"
      />
    </div>
    <span
      v-if="!updateSecurityQuestion && errors.has('security_answer')"
      class="help-block mb-1"
      v-text="errors.get('security_answer')"
    />
    <Transition name="fade">
      <div
        v-if="updateSecurityQuestion"
        class="mb-8 bg-white p-6 pb-0 rounded shadow"
      >
        <SecurityQuestionField
          v-model="securityQuestion"
          label-classes="block text-xs mb-2"
          label="Choose a Security Question"
          :error-message="errors.get('security_question')"
          :questions="securityQuestions.map(option => option.question)"
        />
        <ProfileField
          id="update-security-question-answer"
          v-model="securityAnswer"
          label="Provide an Answer (case-sensitive)"
          :error="errors.get('security_answer')"
        />
      </div>
    </Transition>
  </div>
</template>

<script type="text/babel">
import SecurityQuestionField from 'Auth/Resources/assets/js/components/sms/SecurityQuestionField'
import ProfileField from './ProfileField'

export default {
  name: 'UpdateSecurityQuestionField',
  components: {
    ProfileField,
    SecurityQuestionField,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
    securityQuestions: {
      type: Array,
      required: true,
    },
    hasAnsweredSecurityQuestion: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    updateSecurityQuestion: {
      get() {
        return this.value.update_security_question
      },
      set(value) {
        this.emit({ update_security_question: value })
      },
    },
    securityQuestion: {
      get() {
        return this.value.security_question
      },
      set(value) {
        this.emit({ security_question: value })
      },
    },
    securityAnswer: {
      get() {
        return this.value.security_answer
      },
      set(value) {
        this.emit({ security_answer: value })
      },
    },
  },
  methods: {
    emit(data) {
      this.$emit('input', {
        ...{
          security_question: this.value.security_question,
          security_answer: this.value.security_answer,
          update_security_question: this.value.update_security_question,
        },
        ...data,
      })
    },
  },
}
</script>
